import { render, staticRenderFns } from "./ExportColumnsModal.vue?vue&type=template&id=06a7fc46&scoped=true&"
import script from "./ExportColumnsModal.vue?vue&type=script&lang=js&"
export * from "./ExportColumnsModal.vue?vue&type=script&lang=js&"
import style0 from "./ExportColumnsModal.vue?vue&type=style&index=0&id=06a7fc46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a7fc46",
  null
  
)

export default component.exports